export const educationData = [
    {
        id: 1,
        institution: 'Bhavans Munshi Vidyashram',
        course: 'Higher Secondary Education',
        startYear: '2018',
        endYear: '2020'
    },
    {
        id: 2,
        institution: 'Model Engineering College',
        course: 'Bachelor of Technology in Computer Science',
        startYear: '2020',
        endYear: '2024'
    },
    {
        id: 3,
        institution: 'Model Engineering College',
        course: 'Bachelor of Technology Honours in Advanced Machine Learning',
        startYear: '2022',
        endYear: '2024'
    },
]